import React, { useCallback, useEffect, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { Typography } from '../../DesignSystem';

import './MetaMaskToolTip.scss';

export const MetaMaskToolTip = () => {
    const { t } = useTranslation(['nft']);
    const [isToolTipOpen, setIsToolTipOpen] = useState<boolean>(false);

    const infoRef = useRef<HTMLDivElement>(null);

    const setToolTipOpen = useCallback(() => {
        setIsToolTipOpen(true);
    }, []);

    const setToolTipClose = useCallback(() => {
        setIsToolTipOpen(false);
    }, []);

    useEffect(() => {
        const toolTipRef = infoRef.current;
        if (toolTipRef) {
            toolTipRef.addEventListener('mouseover', setToolTipOpen);
            toolTipRef.addEventListener('mouseout', setToolTipClose);
            return () => {
                toolTipRef.removeEventListener('mouseover', setToolTipOpen);
                toolTipRef.removeEventListener('mouseout', setToolTipClose);
            };
        }
    }, [infoRef, setToolTipOpen, setToolTipClose]);

    return (
        <div className="tooltip">
            <div className={`tooltip__canvas ${isToolTipOpen ? 'tooltip__canvas--is-open' : ''}`}>
                <Typography type="label" size={20} classes={['tooltip__headline']}>
                    {t('what_is_metamask')}
                </Typography>
                <Typography type="paragraph" size={14} classes={['tooltip__text']}>
                    {t('metamask_description')}
                </Typography>
                <div className="tooltip__tip">
                    <div className="artifact-sidebar__tooltip__tip__icon" />
                </div>
            </div>

            <div ref={infoRef} className={'yat-nft-sidebar__metamask-fineprint'}>
                <Typography type="label" size={14}>
                    {t('metamask_why_do_i_need_it')}
                </Typography>
            </div>
        </div>
    );
};
